export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line' },
  { slug: 'jilu', name: '纪录片', icon: 'ri-camera-line' },
  { slug: 'juqing', name: '剧情片', icon: 'ri-film-line' },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-mic-line' },
];

export interface Movie {
  id: number;
  title: string;
  category: string;
  description: string;
  longDescription: string;
  posterUrl: string;
  bannerUrl: string;
  rating: number;
  year: number;
  region: string;
  director: string;
  actors: string[];
  duration: string;
  updateDate: string;
  featured: boolean;
  tags: string[];
  episodes?: string;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    category: 'kehuan',
    description: '人类在遥远星系中发现神秘文明遗迹，一场跨星际的冒险由此展开。特效震撼，剧情扣人心弦。',
    longDescription: '在遥远的未来，人类已经掌握了星际航行技术。一艘探索飞船在猎户座星云边缘发现了一个古老而神秘的外星文明遗迹。随着调查的深入，船员们逐渐发现这个文明背后隐藏着一个足以改变整个银河系命运的秘密。本片由著名导演张导执导，汇聚了国内外一线演员，特效团队倾力打造震撼视觉体验，是今年最值得期待的科幻巨制。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20spaceship%20starry%20sky%20dramatic%20lighting%20warm%20golden%20tones%20cinematic%20professional%20photography%20clean%20dark%20background%20elegant%20composition&width=600&height=800&seq=movie-kehuan-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20spaceship%20flying%20through%20nebula%20dramatic%20cinematic%20lighting%20warm%20golden%20tones%20professional%20film%20photography%20rich%20colors%20elegant%20composition&width=1200&height=675&seq=movie-kehuan-01-banner&orientation=landscape',
    rating: 8.7,
    year: 2026,
    region: '中国大陆/美国',
    director: '张伟明',
    actors: ['刘德华', '吴京', '斯嘉丽·约翰逊', '汤姆·克鲁斯'],
    duration: '148分钟',
    updateDate: '2026-07-28',
    featured: true,
    tags: ['科幻', '冒险', '动作'],
  },
  {
    id: 2,
    title: '长安十二时辰之暗影',
    category: 'dongzuo',
    description: '盛唐时期长安城中暗流涌动，一场关乎帝国命运的暗战正在上演。古装动作巨制。',
    longDescription: '天宝三年，长安城中表面繁华似锦，实则暗流涌动。一名退役暗卫偶然发现了一个针对皇室的惊天阴谋，他必须在十二个时辰内揪出幕后黑手，拯救长安城于危难之中。影片以宏大的盛唐气象为背景，融合了惊险刺激的动作场面与扣人心弦的悬疑情节，再现了那个辉煌时代的壮丽画卷。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20martial%20arts%20movie%20poster%20Tang%20Dynasty%20warrior%20dramatic%20lighting%20red%20gold%20tones%20cinematic%20professional%20photography%20clean%20dark%20background&width=600&height=800&seq=movie-dongzuo-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20ancient%20battle%20scene%20Tang%20Dynasty%20Chang%20an%20city%20dramatic%20cinematic%20lighting%20red%20gold%20warm%20tones%20professional%20film%20photography&width=1200&height=675&seq=movie-dongzuo-01-banner&orientation=landscape',
    rating: 9.1,
    year: 2026,
    region: '中国大陆',
    director: '陈凯歌',
    actors: ['易烊千玺', '周迅', '张译', '雷佳音'],
    duration: '156分钟',
    updateDate: '2026-08-01',
    featured: true,
    tags: ['动作', '古装', '悬疑'],
  },
  {
    id: 3,
    title: '笑傲江湖之风云再起',
    category: 'xiju',
    description: '现代都市中的一群年轻人，在职场与生活中上演啼笑皆非的故事。笑料百出，温情满满。',
    longDescription: '在一家名为"风云科技"的互联网公司里，一群性格迥异的年轻人每天都在上演着令人捧腹的职场喜剧。有技术宅男与产品经理的斗智斗勇，有实习生与老油条的欢乐碰撞，还有那些说不清道不明的办公室恋情。影片以轻松幽默的方式展现了当代年轻人的职场生活与情感世界，笑中带泪，治愈人心。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20office%20workers%20smiling%20bright%20warm%20lighting%20colorful%20playful%20professional%20photography%20clean%20white%20background&width=600&height=800&seq=movie-xiju-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20comedy%20scene%20young%20professionals%20laughing%20bright%20warm%20lighting%20colorful%20playful%20atmosphere%20professional%20film%20photography&width=1200&height=675&seq=movie-xiju-01-banner&orientation=landscape',
    rating: 7.9,
    year: 2026,
    region: '中国大陆',
    director: '宁浩',
    actors: ['沈腾', '马丽', '艾伦', '常远'],
    duration: '118分钟',
    updateDate: '2026-07-25',
    featured: true,
    tags: ['喜剧', '职场', '都市'],
  },
  {
    id: 4,
    title: '那年夏天遇见你',
    category: 'aiqing',
    description: '两个年轻人在最美的夏天相遇，从相识到相爱的浪漫故事。纯爱经典，感动千万人。',
    longDescription: '大学刚毕业的林小夏来到一座陌生的城市工作，在某个夏日的傍晚，她在一家书店邂逅了同样热爱阅读的陆子轩。两个灵魂在书海中找到了彼此，从偶然相遇到相知相爱，他们一起经历了成长中的酸甜苦辣。然而命运却给他们开了一个玩笑，当林小夏收到国外名校的录取通知书时，她必须在爱情与梦想之间做出选择。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%20young%20couple%20summer%20sunlight%20soft%20warm%20pastel%20tones%20cinematic%20professional%20photography%20clean%20elegant%20composition&width=600&height=800&seq=movie-aiqing-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Romantic%20summer%20scene%20young%20couple%20in%20bookstore%20soft%20warm%20sunlight%20pastel%20tones%20cinematic%20professional%20film%20photography%20elegant%20atmosphere&width=1200&height=675&seq=movie-aiqing-01-banner&orientation=landscape',
    rating: 8.3,
    year: 2026,
    region: '中国大陆',
    director: '赵薇',
    actors: ['周冬雨', '刘昊然', '关晓彤', '王俊凯'],
    duration: '132分钟',
    updateDate: '2026-07-20',
    featured: true,
    tags: ['爱情', '青春', '治愈'],
  },
  {
    id: 5,
    title: '暗夜追踪',
    category: 'kongbu',
    description: '一个偏僻小镇连续发生离奇失踪案，警探深入调查发现背后隐藏的恐怖真相。',
    longDescription: '东北某偏僻小镇近期接连发生离奇失踪案件，受害者均在深夜神秘消失，现场未留下任何痕迹。省城刑警队长李牧奉命前往调查，随着调查的深入，他逐渐发现这些案件背后隐藏着一个令人不寒而栗的秘密——一个延续了数百年的古老诅咒正在苏醒。本片营造了极致的悬疑恐怖氛围，每一个镜头都让人屏息凝神。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20movie%20poster%20dark%20foggy%20small%20town%20mysterious%20atmosphere%20dim%20lighting%20cool%20dark%20tones%20cinematic%20professional%20photography%20clean%20composition&width=600&height=800&seq=movie-kongbu-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20small%20town%20at%20night%20dark%20atmosphere%20horror%20film%20scene%20dim%20streetlight%20cinematic%20professional%20photography%20cool%20dark%20tones&width=1200&height=675&seq=movie-kongbu-01-banner&orientation=landscape',
    rating: 7.6,
    year: 2026,
    region: '中国大陆',
    director: '温子仁',
    actors: ['朱一龙', '倪妮', '王传君', '张子枫'],
    duration: '108分钟',
    updateDate: '2026-07-30',
    featured: false,
    tags: ['恐怖', '悬疑', '惊悚'],
  },
  {
    id: 6,
    title: '深海奇缘',
    category: 'donghua',
    description: '勇敢的小鱼踏上了寻找失落王国的冒险旅程，画面精美绝伦，老少皆宜。',
    longDescription: '在蔚蓝深海之中，生活着一群快乐的小鱼。一天，小丑鱼尼尼偶然发现了一张古老的藏宝图，上面记载着一个传说中的失落王国。为了寻找这个神秘的地方，尼尼与他的好朋友们踏上了一段充满未知与惊喜的冒险旅程。这部动画电影以惊艳的视觉效果和温暖人心的故事，带领观众潜入美轮美奂的海底世界。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20colorful%20underwater%20world%20cute%20fish%20characters%20vibrant%20warm%20lighting%20playful%20professional%20illustration%20clean%20composition&width=600&height=800&seq=movie-donghua-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20underwater%20ocean%20scene%20colorful%20coral%20reef%20tropical%20fish%20vibrant%20warm%20lighting%20animated%20movie%20style%20professional%20illustration&width=1200&height=675&seq=movie-donghua-01-banner&orientation=landscape',
    rating: 8.9,
    year: 2026,
    region: '中国大陆/日本',
    director: '田晓鹏',
    actors: ['杨幂(配音)', '黄渤(配音)', '周深(配音)'],
    duration: '105分钟',
    updateDate: '2026-08-02',
    featured: true,
    tags: ['动画', '冒险', '奇幻'],
  },
  {
    id: 7,
    title: '地球脉动：冰封世界',
    category: 'jilu',
    description: '深入极地冰雪世界，记录最震撼的自然奇观与野生动物生存故事。',
    longDescription: '这部纪录片耗时三年拍摄，摄制组深入南极、北极及格陵兰岛等极寒地带，用最先进的4K摄影技术记录下了极地世界令人叹为观止的自然景观和野生动物生存状态。从帝企鹅的繁衍之旅到北极熊的狩猎日常，每一个画面都是对生命坚韧与美丽的礼赞。旁白由著名配音艺术家李立宏倾情演绎。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20movie%20poster%20polar%20ice%20landscape%20penguins%20arctic%20dramatic%20natural%20lighting%20cool%20blue%20white%20tones%20professional%20photography%20clean%20composition&width=600&height=800&seq=movie-jilu-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Stunning%20arctic%20polar%20landscape%20icebergs%20penguins%20colony%20dramatic%20natural%20lighting%20cool%20blue%20white%20tones%20professional%20nature%20photography&width=1200&height=675&seq=movie-jilu-01-banner&orientation=landscape',
    rating: 9.5,
    year: 2026,
    region: '英国/中国大陆',
    director: '大卫·爱登堡',
    actors: ['李立宏(旁白)'],
    duration: '98分钟',
    updateDate: '2026-07-15',
    featured: false,
    tags: ['纪录片', '自然', '极地'],
  },
  {
    id: 8,
    title: '逆流时光',
    category: 'juqing',
    description: '一位中年男子意外获得重返过去的能力，他开始修正人生中每一个遗憾。',
    longDescription: '四十五岁的陈默是一个普通的中年男人，事业平淡，婚姻濒临破裂。一天，他在整理旧物时发现了一台老式收音机，当收音机播放出一首老歌时，他惊讶地发现自己回到了二十年前。有了重新来过的机会，陈默开始小心翼翼地修正那些曾经让他后悔的选择，却发现每一次改变都带来了意想不到的连锁反应。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%20middle-aged%20man%20looking%20thoughtful%20warm%20nostalgic%20lighting%20amber%20tones%20cinematic%20professional%20photography%20clean%20elegant%20composition&width=600&height=800&seq=movie-juqing-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20scene%20man%20looking%20at%20old%20radio%20in%20cozy%20room%20amber%20sunlight%20cinematic%20professional%20film%20photography%20elegant%20atmosphere&width=1200&height=675&seq=movie-juqing-01-banner&orientation=landscape',
    rating: 8.5,
    year: 2026,
    region: '中国大陆',
    director: '贾樟柯',
    actors: ['徐峥', '谭卓', '王景春', '海清'],
    duration: '142分钟',
    updateDate: '2026-07-18',
    featured: false,
    tags: ['剧情', '奇幻', '家庭'],
  },
  {
    id: 9,
    title: '消失的证人',
    category: 'xuanyi',
    description: '一桩看似完美的谋杀案，唯一的证人却凭空消失，真相扑朔迷离。',
    longDescription: '知名企业家在豪华别墅中被杀，现场被精心布置成一桩入室抢劫案。警方在调查中发现了一个关键证人——被害者的私人秘书。然而就在即将出庭作证的前一天，这位秘书却像人间蒸发般消失得无影无踪。私家侦探秦风接手此案，他必须在有限的时间内找到失踪的证人，揭开这起案件背后的惊人真相。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20movie%20poster%20dark%20rainy%20city%20street%20noir%20atmosphere%20dramatic%20lighting%20cool%20dark%20tones%20cinematic%20professional%20photography%20clean%20composition&width=600&height=800&seq=movie-xuanyi-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20city%20street%20noir%20atmosphere%20mystery%20film%20scene%20detective%20silhouette%20dramatic%20lighting%20cool%20dark%20tones%20professional%20film%20photography&width=1200&height=675&seq=movie-xuanyi-01-banner&orientation=landscape',
    rating: 8.1,
    year: 2026,
    region: '中国大陆',
    director: '曹保平',
    actors: ['段奕宏', '邓超', '刘浩存', '于和伟'],
    duration: '126分钟',
    updateDate: '2026-07-22',
    featured: false,
    tags: ['悬疑', '犯罪', '推理'],
  },
  {
    id: 10,
    title: '决战斯大林格勒',
    category: 'zhanzheng',
    description: '还原二战最惨烈战役，展现人性在炮火中的光辉与坚韧。战争史诗巨制。',
    longDescription: '1942年，德军兵临斯大林格勒城下，苏联军民展开了史上最惨烈的城市保卫战。影片以一个小分队的视角切入，真实还原了那段血与火的历史。在废墟与硝烟中，普通士兵们的勇气、友情与牺牲精神熠熠生辉。本片投资超过十亿，动用上万名群众演员，力求在银幕上重现那段震撼人心的历史。',
    posterUrl: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20soldiers%20in%20battle%20ruined%20city%20dramatic%20lighting%20dark%20orange%20smoke%20tones%20cinematic%20professional%20photography%20clean%20composition&width=600&height=800&seq=movie-zhanzheng-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Epic%20war%20battle%20scene%20ruined%20city%20smoke%20dramatic%20cinematic%20lighting%20dark%20orange%20tones%20professional%20film%20photography%20soldiers%20advancing&width=1200&height=675&seq=movie-zhanzheng-01-banner&orientation=landscape',
    rating: 8.8,
    year: 2026,
    region: '中国大陆/俄罗斯',
    director: '管虎',
    actors: ['张涵予', '段奕宏', '姜武', '王千源'],
    duration: '168分钟',
    updateDate: '2026-07-10',
    featured: true,
    tags: ['战争', '历史', '史诗'],
  },
  {
    id: 11,
    title: '大明风华录',
    category: 'dianshiju',
    description: '大型历史古装剧，讲述明朝永乐年间的宫廷风云与家国情怀。全58集。',
    longDescription: '本剧以明朝永乐年间为背景，讲述了明成祖朱棣迁都北京后，朝廷内外的权力博弈与家族恩怨。从郑和下西洋到编纂永乐大典，从靖难之役的余波到仁宣之治的开启，一幅波澜壮阔的历史画卷徐徐展开。剧中既有惊心动魄的朝堂斗争，也有感人至深的儿女情长。全剧共58集，制作精良，场面宏大。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20Ming%20Dynasty%20imperial%20court%20elegant%20gold%20red%20tones%20cinematic%20professional%20photography%20clean%20dark%20background&width=600&height=800&seq=movie-dianshiju-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Chinese%20Ming%20Dynasty%20imperial%20palace%20court%20scene%20elegant%20gold%20red%20dramatic%20lighting%20historical%20costume%20drama%20cinematic%20professional%20film%20photography&width=1200&height=675&seq=movie-dianshiju-01-banner&orientation=landscape',
    rating: 9.0,
    year: 2026,
    region: '中国大陆',
    director: '张黎',
    actors: ['陈道明', '汤唯', '朱亚文', '张若昀'],
    duration: '45分钟/集',
    updateDate: '2026-08-01',
    featured: true,
    tags: ['电视剧', '古装', '历史'],
    episodes: '全58集',
  },
  {
    id: 12,
    title: '奔跑吧！欢乐季',
    category: 'zongyi',
    description: '全新一季明星户外真人秀，更有趣的游戏，更精彩的挑战，笑到停不下来。',
    longDescription: '《奔跑吧！欢乐季》是年度最受欢迎的户外竞技真人秀节目。本季节目邀请了八位当红明星组成"欢乐家族"，他们将走遍全国各地，在美丽的自然风光中完成各种趣味横生的挑战任务。从古镇寻宝到海边闯关，从美食对决到团队协作，每一期都充满欢声笑语和意想不到的惊喜。本季还特别加入了观众互动环节，让电视机前的你也能参与其中。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20celebrities%20running%20outdoor%20bright%20colorful%20cheerful%20warm%20sunlight%20professional%20photography%20clean%20white%20background&width=600&height=800&seq=movie-zongyi-01&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20scene%20celebrities%20playing%20games%20bright%20sunlight%20colorful%20cheerful%20atmosphere%20professional%20film%20photography&width=1200&height=675&seq=movie-zongyi-01-banner&orientation=landscape',
    rating: 8.4,
    year: 2026,
    region: '中国大陆',
    director: '浙江卫视',
    actors: ['李晨', '杨颖', '郑恺', '沙溢', '白鹿', '周深', '范丞丞', '张真源'],
    duration: '90分钟/期',
    updateDate: '2026-07-31',
    featured: true,
    tags: ['综艺', '户外', '竞技'],
    episodes: '更新至第8期',
  },
  {
    id: 13,
    title: '追凶者也2',
    category: 'dongzuo',
    description: '硬汉刑警跨国追凶，从东南亚丛林到欧洲古堡，拳拳到肉的动作盛宴。',
    longDescription: '前特种兵出身的刑警队长高飞接到任务，追捕一名潜逃海外的国际通缉犯。从泰国曼谷的热带雨林到法国南部的古老城堡，从激烈的街头枪战到惊险的直升机追逐，高飞凭借过人的身手和智慧，一步步逼近目标。然而在一次次的交锋中，他逐渐发现这起案件背后隐藏着一个更大的国际犯罪网络。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20tough%20cop%20holding%20gun%20dramatic%20lighting%20dark%20warm%20tones%20cinematic%20professional%20photography%20clean%20composition&width=600&height=800&seq=movie-dongzuo-02&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Intense%20action%20scene%20car%20chase%20in%20tropical%20jungle%20road%20dramatic%20cinematic%20lighting%20warm%20dark%20tones%20professional%20film%20photography&width=1200&height=675&seq=movie-dongzuo-02-banner&orientation=landscape',
    rating: 8.0,
    year: 2026,
    region: '中国大陆/泰国/法国',
    director: '林超贤',
    actors: ['彭于晏', '张晋', '托尼·贾', '甄子丹'],
    duration: '135分钟',
    updateDate: '2026-07-29',
    featured: false,
    tags: ['动作', '犯罪', '跨国'],
  },
  {
    id: 14,
    title: '夏洛特的网',
    category: 'donghua',
    description: '经典童话全新改编，一只聪明小猪与蜘蛛夏洛特之间的温暖友谊。',
    longDescription: '在宁静的农场里，春天出生的小猪威尔伯得知自己将在冬天被做成熏肉，它陷入了深深的恐惧之中。幸运的是，它遇到了住在谷仓门框上的蜘蛛夏洛特。聪明的夏洛特想出了一个绝妙的计划——用自己的网织出赞美威尔伯的文字，让农场主相信这是一只与众不同的小猪。一段跨越物种的真挚友谊，温暖了无数人的心。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20cute%20pig%20and%20spider%20in%20farm%20barn%20warm%20sunlight%20soft%20pastel%20colors%20professional%20illustration%20clean%20composition&width=600&height=800&seq=movie-donghua-02&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20farm%20barn%20scene%20warm%20sunlight%20straw%20animals%20cute%20pig%20soft%20pastel%20colors%20animated%20movie%20style%20professional%20illustration&width=1200&height=675&seq=movie-donghua-02-banner&orientation=landscape',
    rating: 8.6,
    year: 2026,
    region: '中国大陆/美国',
    director: '饺子',
    actors: ['邓超(配音)', '孙俪(配音)', '等等(配音)'],
    duration: '95分钟',
    updateDate: '2026-07-26',
    featured: false,
    tags: ['动画', '童话', '友情'],
  },
  {
    id: 15,
    title: '黑暗森林法则',
    category: 'kehuan',
    description: '基于刘慈欣小说改编，人类面对宇宙黑暗森林法则的终极生存之战。',
    longDescription: '三体危机之后，人类文明进入了新的纪元。面对宇宙中无数未知的文明，人类必须学会在"黑暗森林"中生存。一支由最顶尖科学家和军人组成的特别小队被派往外太空，执行一项关乎人类命运的秘密任务。本片以惊人的想象力构建了一个宏大而残酷的宇宙图景，探讨了文明存续的终极命题。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20dark%20space%20stars%20mysterious%20planet%20dramatic%20lighting%20deep%20dark%20blue%20tones%20cinematic%20professional%20photography%20clean%20composition&width=600&height=800&seq=movie-kehuan-02&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Deep%20space%20scene%20mysterious%20planet%20stars%20galaxy%20dramatic%20cinematic%20lighting%20dark%20blue%20cosmic%20tones%20professional%20sci-fi%20film%20photography&width=1200&height=675&seq=movie-kehuan-02-banner&orientation=landscape',
    rating: 9.3,
    year: 2026,
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '宁理'],
    duration: '175分钟',
    updateDate: '2026-07-12',
    featured: true,
    tags: ['科幻', '宇宙', '文明'],
  },
  {
    id: 16,
    title: '舌尖上的家乡味',
    category: 'jilu',
    description: '走遍中国大江南北，探寻最地道的家乡味道与美食背后的温情故事。',
    longDescription: '这部美食纪录片以"家乡味"为主题，摄制组走遍了中国的每一个省份，深入到大山深处的古村落和繁华都市的街巷弄堂，寻访那些承载着一方水土记忆的传统美食。从东北的酸菜炖粉条到广东的煲仔饭，从四川的麻辣火锅到江南的蟹粉小笼，每一道美食背后都有一个关于家、关于记忆、关于传承的动人故事。',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20delicious%20traditional%20dishes%20warm%20steaming%20lighting%20rich%20colors%20professional%20food%20photography%20clean%20dark%20background&width=600&height=800&seq=movie-jilu-02&orientation=portrait',
    bannerUrl: 'https://readdy.ai/api/search-image?query=Chinese%20traditional%20food%20kitchen%20scene%20steaming%20dishes%20warm%20lighting%20rich%20colors%20professional%20food%20photography%20rustic%20atmosphere&width=1200&height=675&seq=movie-jilu-02-banner&orientation=landscape',
    rating: 9.2,
    year: 2026,
    region: '中国大陆',
    director: '陈晓卿',
    actors: ['李立宏(旁白)'],
    duration: '50分钟/集',
    updateDate: '2026-07-19',
    featured: false,
    tags: ['纪录片', '美食', '人文'],
    episodes: '全12集',
  },
];

export const getMoviesByCategory = (categorySlug: string): Movie[] => {
  return movies.filter((m) => m.category === categorySlug);
};

export const getFeaturedMovies = (): Movie[] => {
  return movies.filter((m) => m.featured);
};

export const getLatestMovies = (count: number = 8): Movie[] => {
  return [...movies].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, count);
};

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getCategoryName = (slug: string): string => {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
};